import { ROLE_SHELL_BASE_PATHS } from "./roleShellConfig";

/** First URL segments that are not dynamic role dashboards. */
const STATIC_SEGMENTS = new Set([
  "app",
  "about",
  "contact",
  "donate",
  "tournaments",
  "admin-login",
  "user-login",
  "donor-login",
  "student-login",
  "session-timeout",
]);

export function isReservedRoleShellSegment(segment) {
  const slug = String(segment ?? "").trim().toLowerCase();
  if (!slug) return true;
  if (STATIC_SEGMENTS.has(slug)) return true;
  return ROLE_SHELL_BASE_PATHS.has(slug);
}
